import { render, staticRenderFns } from "./FaqStats.vue?vue&type=template&id=207b8590"
import script from "./FaqStats.vue?vue&type=script&lang=js"
export * from "./FaqStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports